import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { themeStructure } from "@vcl";
import { camelToTitleCase } from "@bloglovin/vue-framework";

export default class BorderWidth extends BaseOption {
  static userInterfaceComponent = () => {

    const options = themeStructure.size.border.map(value => {
      return {
        id: value,
        name: camelToTitleCase(value),
      };
    });

    return {
      label: "Border Size",
      component: inspectorTools.SIMPLE_PICKER,
      props: {
        options,
      },
    };
  };

  static defaultValue = "none";

  static convertConfigValueToCompiledValue(configValue, themeId) {
    return BaseOption._getStyleValuePropertiesFromTheme("size.border", themeId)[configValue];
  }
}
